import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from "redux-persist";

const initialState = {
    title:"",
    id:"",
    email:"",
    scrollToPosition:"",
    navigateTo:0,
    sideBar:true,
    previousNode:null
}

export const navigateSlice = createSlice({
    name: 'navigateSlice',
    initialState,
    reducers: {
        setNavigateTo:(state,action)=>{
            state.navigateTo=action.payload
        },
        setTitle:(state,action)=>{
            state.title=action.payload
        },
        setId:(state,action)=>{
            state.id=action.payload
        },
        setEmail:(state,action)=>{
            state.email=action.payload
        },
        setSideBar:(state,action)=>{
            state.sideBar=action.payload
        },
        setPreviousNode:(state,action)=>{
            state.previousNode=action.payload
        }
        
    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => initialState); // THIS LINE
    }
})

export const { setTitle,setNavigateTo,setId,setEmail,setSideBar,setPreviousNode} = navigateSlice.actions
export default navigateSlice.reducer